import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export const CodeBlock = ({ code, language, tabs, testId = 'code-block' }) => {
  const [active, setActive] = useState(tabs ? tabs[0].label : null);
  const [copied, setCopied] = useState(false);
  const current = tabs ? tabs.find((t) => t.label === active) : { code, label: language };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(current.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {}
  };

  return (
    <div className="rounded-lg border border-white/10 bg-zinc-950 overflow-hidden" data-testid={testId}>
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-white/5 bg-zinc-900/60">
        <div className="flex gap-1">
          {tabs ? tabs.map((t) => (
            <button
              key={t.label}
              onClick={() => setActive(t.label)}
              data-testid={`${testId}-tab-${t.label.toLowerCase()}`}
              className={`text-[11px] px-2 py-1 rounded-md font-mono transition-colors ${active === t.label ? 'bg-cyan-500/15 text-cyan-300' : 'text-zinc-500 hover:text-zinc-300'}`}
            >
              {t.label}
            </button>
          )) : <span className="text-[11px] font-mono text-zinc-500">{language}</span>}
        </div>
        <button onClick={copy} data-testid={`${testId}-copy`} className="text-zinc-500 hover:text-white transition-colors p-1" title="Copiar">
          {copied ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <Copy className="w-3.5 h-3.5" />}
        </button>
      </div>
      <pre className="p-3 text-[11.5px] leading-relaxed font-mono text-zinc-300 overflow-x-auto whitespace-pre">{current.code}</pre>
    </div>
  );
};
